import './template'
import './yumiwi'



// WEBPACK FOOTER //
// ./resources/assets/command-center/js/scripts/index.js